import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./AwardsRecognization.css";
import CountUp from 'react-countup';

const AwardsRecognization = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const logos = [
    { src: `${process.env.PUBLIC_URL}/awardsandrecognization/QB8mg12l_400x400.png`, alt: "Cert-1" },
    { src: `${process.env.PUBLIC_URL}/awardsandrecognization/images.png`, alt: "Cert-2" },
    { src: `${process.env.PUBLIC_URL}/awardsandrecognization/Screenshot 2025-07-13 181245.png`, alt: "Cert-3" },
    { src: `${process.env.PUBLIC_URL}/awardsandrecognization/Screenshot 2025-07-13 181252.png`, alt: "Cert-4" },
  ];

  const achievements = [
    { value: "66+", labelTop: "Students Placements", labelBottom: "in 2023" },
    { value: "83+", labelTop: "Students Placements", labelBottom: "in 2024" },
    { value: "1200+", labelTop: "And Internships for", labelBottom: "Students Globally" },
  ];

  return (
    <section className="awards-section" id="awards">
      <h2 className="awards-heading" data-aos="fade-down">Recognized & Certified By</h2>
      <img
        src="/awardsandrecognization/award-design-line-desktop-2x.png"
        alt=""
        className="divider-img"
        data-aos="zoom-in"
      />

      {/* Logos */}
      <div className="awards-logo-grid">
        {logos.map(({ src, alt }, i) => (
          <div className="awards-logo-item" key={i} data-aos="fade-up" data-aos-delay={i * 100}>
            <img src={src} alt={alt} className={`awards-logo-img ${i===0 || i === 2 || i === 3 ? "large-logo" : ""}`} />
          </div>
        ))}
      </div>

      {/* Achievements */}
      <h2 className="awards-heading" data-aos="fade-left">Achievements</h2>
      <div className="achievements-grid">
        {achievements.map(({ value, labelTop, labelBottom }, i) => (
          <div key={i} className="ach-item" data-aos="zoom-in-up" data-aos-delay={i * 150}>
            <p className="top">{labelTop}</p>
            <div className="bubble bubble-animate">
              <CountUp
                end={parseInt(value)}
                duration={2.5}
                suffix="+"
                enableScrollSpy
                scrollSpyDelay={300}
              />
            </div>
            <p className="bottom">{labelBottom}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AwardsRecognization;
